var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLoanServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 137,
    viewBox: "0 0 145 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2025_378)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.9447,
    cy: 60.6194,
    rx: 28.4354,
    ry: 22.342,
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.9447,
    cy: 56.5569,
    rx: 28.4354,
    ry: 22.342,
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5984 64.9033L35.4893 43.3626H40.6463L44.4546 58.5165H44.653L48.501 43.3626H53.6184L57.506 58.4371H57.7044L61.473 43.3626H66.6301L60.5209 64.9033H55.2448L51.1985 50.3048H50.9208L46.8745 64.9033H41.5984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5629,
    cy: 99.8508,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5629,
    cy: 95.7883,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2166 104.136L13.1074 82.595H18.2645L22.0728 97.7489H22.2712L26.1191 82.595H31.2365L35.1242 97.6696H35.3225L39.0912 82.595H44.2482L38.1391 104.136H32.863L28.8167 89.5372H28.539L24.4927 104.136H19.2166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4896,
    cy: 87.9289,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4896,
    cy: 83.8664,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1424 92.2139L13.0332 70.6732H18.1903L21.9986 85.827H22.1969L26.0449 70.6732H31.1623L35.05 85.7477H35.2483L39.0169 70.6732H44.174L38.0649 92.2139H32.7888L28.7425 77.6154H28.4648L24.4184 92.2139H19.1424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4895,
    cy: 75.6702,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4895,
    cy: 71.6077,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1424 79.9551L13.0332 58.4144H18.1903L21.9986 73.5682H22.1969L26.0449 58.4144H31.1623L35.05 73.4889H35.2483L39.0169 58.4144H44.174L38.0649 79.9551H32.7888L28.7425 65.3566H28.4648L24.4184 79.9551H19.1424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.51,
    cy: 113.755,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.51,
    cy: 109.693,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.164 118.04L101.055 96.4993H106.212L110.02 111.653H110.219L114.067 96.4993H119.184L123.072 111.574H123.27L127.039 96.4993H132.196L126.087 118.04H120.811L116.764 103.442H116.487L112.44 118.04H107.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 101.832,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 97.7698,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09 106.118L100.981 84.5774H106.138L109.946 99.7313H110.145L113.993 84.5774H119.11L122.998 99.652H123.196L126.965 84.5774H132.122L126.012 106.118H120.736L116.69 91.5197H116.412L112.366 106.118H107.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 89.5735,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 85.511,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09 93.8594L100.981 72.3187H106.138L109.946 87.4725H110.145L113.993 72.3187H119.11L122.998 87.3932H123.196L126.965 72.3187H132.122L126.012 93.8594H120.736L116.69 79.2609H116.412L112.366 93.8594H107.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 77.509,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 73.4465,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09 81.7939L100.981 60.2532H106.138L109.946 75.4071H110.145L113.993 60.2532H119.11L122.998 75.3278H123.196L126.965 60.2532H132.122L126.012 81.7939H120.736L116.69 67.1954H116.412L112.366 81.7939H107.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 66.3069,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 62.2444,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09 70.5918L100.981 49.0511H106.138L109.946 64.205H110.145L113.993 49.0511H119.11L122.998 64.1256H123.196L126.965 49.0511H132.122L126.012 70.5918H120.736L116.69 55.9933H116.412L112.366 70.5918H107.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 55.6819,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 51.6194,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09 59.9668L100.981 38.4261H106.138L109.946 53.58H110.145L113.993 38.4261H119.11L122.998 53.5006H123.196L126.965 38.4261H132.122L126.012 59.9668H120.736L116.69 45.3683H116.412L112.366 59.9668H107.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 46.7151,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.437,
    cy: 42.6526,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.09 51L100.981 29.4593H106.138L109.946 44.6132H110.145L113.993 29.4593H119.11L122.998 44.5338H123.196L126.965 29.4593H132.122L126.012 51H120.736L116.69 36.4015H116.412L112.366 51H107.09Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2025_378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.892,
    height: 136.097,
    fill: "white",
    transform: "translate(0.0541077)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoanServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcLoanServiceBodyMobile.2b3a896b9695765656886a8971fb05ff.svg";
export { ForwardRef as ReactComponent };